/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  UpdateActiveApplicationActionPayload,
  UpdateActiveApplicationSuccessfulActionPayload,
  GetApplicationsSuccessfulActionPayload,
  GetApplicationByIdActionPayload,
  GetApplicationByIdSuccessfulActionPayload,
  CreateApplicationSuccessfulActionPayload,
  UpdateApplicationActionPayload,
  UpdateApplicationSuccessfulActionPayload,
  DeleteApplicationActionPayload,
  DeleteApplicationSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/application-data-store';

/* action types */
export enum ActionTypes {
  UpdateActiveApplication = '[APPLICATION] UpdateActiveApplication',
  UpdateActiveApplicationSuccessful = '[APPLICATION] UpdateActiveApplicationSuccessful',
  UpdateActiveApplicationFailure = '[APPLICATION] UpdateActiveApplicationFailure',
  GetApplications = '[APPLICATION] GetApplications',
  GetApplicationsSuccessful = '[APPLICATION] GetApplicationsSuccessful',
  GetApplicationsFailure = '[APPLICATION] GetApplicationsFailure',
  GetApplicationById = '[APPLICATION] GetApplicationById',
  GetApplicationByIdSuccessful = '[APPLICATION] GetApplicationByIdSuccessful',
  GetApplicationByIdFailure = '[APPLICATION] GetApplicationByIdFailure',
  CreateApplication = '[APPLICATION] CreateApplication',
  CreateApplicationSuccessful = '[APPLICATION] CreateApplicationSuccessful',
  CreateApplicationFailure = '[APPLICATION] CreateApplicationFailure',
  UpdateApplication = '[APPLICATION] UpdateApplication',
  UpdateApplicationSuccessful = '[APPLICATION] UpdateApplicationSuccessful',
  UpdateApplicationFailure = '[APPLICATION] UpdateApplicationFailure',
  DeleteApplication = '[APPLICATION] DeleteApplication',
  DeleteApplicationSuccessful = '[APPLICATION] DeleteApplicationSuccessful',
  DeleteApplicationFailure = '[APPLICATION] DeleteApplicationFailure',
  ResetState = '[APPLICATION] ResetState',
}

/* actions */

export const UpdateActiveApplication = createAction(
  ActionTypes.UpdateActiveApplication,
  props<{ payload: UpdateActiveApplicationActionPayload }>(),
);

export const UpdateActiveApplicationSuccessful = createAction(
  ActionTypes.UpdateActiveApplicationSuccessful,
  props<{ payload: UpdateActiveApplicationSuccessfulActionPayload }>(),
);

export const UpdateActiveApplicationFailure = createAction(
  ActionTypes.UpdateActiveApplicationFailure,
);

/* This event gets the all Applications. */
export const GetApplications = createAction(ActionTypes.GetApplications);

/* This event is fired after getting all the Applications successfully. */
export const GetApplicationsSuccessful = createAction(
  ActionTypes.GetApplicationsSuccessful,
  props<{ payload: GetApplicationsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Applications. */
export const GetApplicationsFailure = createAction(
  ActionTypes.GetApplicationsFailure,
);

/* This event gets the Application by Application id. */
export const GetApplicationById = createAction(
  ActionTypes.GetApplicationById,
  props<{ payload: GetApplicationByIdActionPayload }>(),
);

/* This event is fired after getting all the Application by Application id successfully. */
export const GetApplicationByIdSuccessful = createAction(
  ActionTypes.GetApplicationByIdSuccessful,
  props<{ payload: GetApplicationByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Application by Application id successfully. */
export const GetApplicationByIdFailure = createAction(
  ActionTypes.GetApplicationByIdFailure,
);

/* This event creates a Application. */
export const CreateApplication = createAction(ActionTypes.CreateApplication);

/* This event is fired after creating a Application successfully. */
export const CreateApplicationSuccessful = createAction(
  ActionTypes.CreateApplicationSuccessful,
  props<{ payload: CreateApplicationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Application successfully. */
export const CreateApplicationFailure = createAction(
  ActionTypes.CreateApplicationFailure,
);

/* This event updates a Application. */
export const UpdateApplication = createAction(
  ActionTypes.UpdateApplication,
  props<{ payload: UpdateApplicationActionPayload }>(),
);

/* This event is fired after updating a Application successfully. */
export const UpdateApplicationSuccessful = createAction(
  ActionTypes.UpdateApplicationSuccessful,
  props<{ payload: UpdateApplicationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Application successfully. */
export const UpdateApplicationFailure = createAction(
  ActionTypes.UpdateApplicationFailure,
);

/* This event deletes a Application. */
export const DeleteApplication = createAction(
  ActionTypes.DeleteApplication,
  props<{ payload: DeleteApplicationActionPayload }>(),
);

/* This event is fired after deleting a Application successfully. */
export const DeleteApplicationSuccessful = createAction(
  ActionTypes.DeleteApplicationSuccessful,
  props<{ payload: DeleteApplicationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Application successfully. */
export const DeleteApplicationFailure = createAction(
  ActionTypes.DeleteApplicationFailure,
);

/* This event resets the Application state. */
export const ResetState = createAction(ActionTypes.ResetState);
